import { Component, OnInit, inject } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { SessionKey } from "@shared/clickar-constants";
import { UserDTO } from "@shared/model/user.model";
import { ApiService } from "@shared/services/api.service";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { UsersService } from "@shared/services/users/users.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-privacy",
	templateUrl: "./privacy.component.html",
	styleUrl: "./privacy.component.scss",
	standalone: false
})
export class PrivacyComponent implements OnInit {
	private userService = inject(UsersService);
	private storageService = inject(StorageManagerService);
	private apiService = inject(ApiService);
	private router = inject(Router);
	wcmService = inject(WcmService);

	userForm: UntypedFormGroup = new UntypedFormGroup({
		consent1: new UntypedFormControl("", [Validators.required]),
		consent2: new UntypedFormControl("", [Validators.required]),
		consent3: new UntypedFormControl("", [Validators.required])
	});

	user: UserDTO;

	ngOnInit() {
		/* const reader = new FileReader(),
			reader2 = new FileReader(),
			reader3 = new FileReader(); */

		this.userService.getProfileOfLoggedUser().subscribe(value => {
			this.user = value;
			this.userForm.patchValue(value);
		});
	}

	save() {
		if (!this.userForm.invalid) {
			const payload = this.userForm.getRawValue();

			this.user.consent1 = payload.consent1;
			this.user.consent2 = payload.consent2;
			this.user.consent3 = payload.consent3;

			this.apiService.editUserUsingPUT(this.user).subscribe((/* value */) => {
				this.storageService.setSessionItem(
					SessionKey.USER_PROFILE,
					this.user
				);
				this.router.navigate(["/private"]);
			});
		}
	}
}